import React from 'react';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import Link from "@amzn/meridian/link";
import Text from "@amzn/meridian/text";
import './UserUnAuthenticatedPage.scss';
import {buildRegionalizedUrlFromToolUrl} from "src/utils/filter-utils";

const redirectTo = () => {
    const toolUrl = window.location.origin;
    return buildRegionalizedUrlFromToolUrl(toolUrl);
}

const UserUnAuthenticatedPage: React.FC = () => {

  return(
    <div className="unauthenticated">
        <Text type='h100'>
        {AppStrings.USER_AUTHENTICATION_FAILED}
        </Text> 
        <Text>
        {AppStrings.PLEASE_LOGIN_THROUGH}
          <Link href = {redirectTo()}
          >
            {AppStrings.FCMENU}
          </Link>
          {AppStrings.SELECT_APPROPRIATE_TOOL}
        </Text>
    </div>
)};

export default UserUnAuthenticatedPage;